import { render, staticRenderFns } from "./officers.vue?vue&type=template&id=455bddeb&scoped=true"
import script from "./officers.vue?vue&type=script&lang=js"
export * from "./officers.vue?vue&type=script&lang=js"
import style0 from "./officers.vue?vue&type=style&index=0&id=455bddeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455bddeb",
  null
  
)

export default component.exports